<template>
	<pre v-html="$t('terms.agreement9')"></pre>
</template>

<script>
export default {
	name: 'Agreement9',
};
</script>

<style scoped></style>
